import { API_URL } from '../config/config'

import { createJsonHeaders } from './api'

//TODO find better way for chatId and botId
export const getFeedbackFormConfigApi = (botId, chatId) =>
  fetch(
    `${API_URL}/feedbackConfigs/${botId}?chatId=${chatId}`,
    {
      credentials: 'same-origin',
      headers: createJsonHeaders(),
      method: 'GET',
    },
  )

export const sendFeedbackApi = (botId, body) =>
  fetch(`${API_URL}/feedback/${botId}`, {
    credentials: 'same-origin',
    headers: createJsonHeaders(),
    method: 'POST',
    body: JSON.stringify(body),
  }).catch(error => console.log(error))
